export const geoLocationMock = {
  "city": "Richmond",
  "stateProvCode": "VA"
}